<template>
    <div  v-if="isLargeScreen">
        <div>

        <Breadcrumbs main="Profile" title="Profile" />

        <div class="container-fluid">
            <div class="row widget-grid m-lg-5  d-flex align-items-stretch">
                <Informaction />
                <Account />
            </div>
        </div>
        </div>
    </div>
    <div v-else>
        <MobileProfile />
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import Informaction from './informaction.vue';
import Account from './account.vue';
import MobileProfile from './mobile/index.vue';

const isLargeScreen = ref(true);
  
  // 檢查螢幕大小
  function checkScreenSize() {
    isLargeScreen.value = window.innerWidth >= 992;
  }
  
  onMounted(() => {
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
  });
  
  onUnmounted(() => {
    window.removeEventListener('resize', checkScreenSize);
  });
</script>